// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_FranchiseIdQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET payroll endpoints that read a single franchise_id
 * from the query string.
 *
 * franchise_id is nullable so the controller keeps its existing
 * "franchise_id obrigatório" guard (preserving the legacy error message).
 *
 * Shared by:
 * - GET /payroll/period/{id}?franchise_id=X
 * - GET /payroll/undo_period_preview/{id}?franchise_id=X
 * - GET /payroll/period_summary/{id}?franchise_id=X
 * - GET /payroll/available_expenses/{id}?franchise_id=X
 * - GET /payroll/execution/{id}?franchise_id=X
 * - DELETE /payroll/delete_deduction/{id}?franchise_id=X
 * - DELETE /payroll/delete_receipt/{id}?franchise_id=X
 * - GET /payroll/period_payments/{id}?franchise_id=X
 * - DELETE /payroll/delete_advance/{id}?franchise_id=X
 * - GET /payroll/employee_deduction/{id}?franchise_id=X
 * - GET /payroll/employee_advance/{id}?franchise_id=X
 */
import { registerContract } from './validate'

export interface Payroll_FranchiseIdQueryInput {
franchise_id?: number
}

registerContract('Payroll_FranchiseIdQueryInput', {
  franchise_id: { type: 'number',  required: false },
})
